




















































import Vue, {VueConstructor} from 'vue'
import {DateTime, DateObject} from 'luxon'
import {fieldProps} from '../BZCore/ActiveField'

interface IValue {
  value: number
}

export default (Vue as VueConstructor<Vue & {
  value: DateObject
}>).extend({
  name: 'DateInputField',
  props: {
    ...fieldProps,
    yearStart: {
      type: Number,
      default: 1900
    },
    yearEnd: {
      type: Number,
      default: (new Date()).getFullYear()
    }
  },
  data () {
    return {
      date: {
        year: null as null | number,
        month: null as null | number,
        day: null as null | number
      },
      months: [
        {value: 1, label: this.$t('labels.months1["1"]')},
        {value: 2, label: this.$t('labels.months1["2"]')},
        {value: 3, label: this.$t('labels.months1["3"]')},
        {value: 4, label: this.$t('labels.months1["4"]')},
        {value: 5, label: this.$t('labels.months1["5"]')},
        {value: 6, label: this.$t('labels.months1["6"]')},
        {value: 7, label: this.$t('labels.months1["7"]')},
        {value: 8, label: this.$t('labels.months1["8"]')},
        {value: 9, label: this.$t('labels.months1["9"]')},
        {value: 10, label: this.$t('labels.months1["10"]')},
        {value: 11, label: this.$t('labels.months1["11"]')},
        {value: 12, label: this.$t('labels.months1["12"]')}
      ]
    }
  },
  methods: {
    reset () {
      this.date.year = null
      this.date.month = null
      this.date.day = null
    },
    emit (): void {
      this.$emit('input', this.date)
    },
    setDefaultDate (): void {
      console.log('value', this.value)
      if (this.value) {
        if (typeof this.value !== 'object') {
          return;
        }
        // @ts-ignore
        this.date.year = this.value.year;
        // @ts-ignore
        this.date.month = this.value.month;
        // @ts-ignore
        this.date.day = this.value.day;
      }
    }
  },
  computed: {
    years (): IValue[] {
      const years: IValue[] = []
      for (let i = this.yearEnd; i >= this.yearStart; i--) {
        years.push({value: i})
      }
      return years
    },
    days (): IValue[] {
      let date
      if (this.date.year && this.date.month) {
        date = DateTime.fromObject({year: this.date.year, month: this.date.month});
      }

      let length = date ? date.daysInMonth : 31
      const days: IValue[] = []
      for (let i = 0; i < length; i++) {
        days.push({value: i + 1})
      }
      return days
    },
    isValid (): boolean {
      if (this.date.year && this.date.month && this.date.day) {
        const curentDate = DateTime.local();
        const checkedDate = DateTime.fromObject(this.date as object);
        return checkedDate.isValid && checkedDate.valueOf() < curentDate.valueOf();
      } else {
        return true;
      }
    }
  },
  mounted () {
    this.setDefaultDate()
  },
  watch: {
    'days.length' () {
      if (this.date.day && this.days.length < this.date.day) {
        this.date.day = this.days.length
      }
    },
    date: {
      handler: function () {
        this.emit();
      },
      deep: true
    }
  }
})
